import type { BackendApiErrorUnion } from '@vs-shop/engine/data/error/backendApi/_internal/createBackendApiError';
import { makeTaxonModule } from '@vs-shop/engine/module/taxon/makeTaxonModule';
import { TaxonMenu } from '../schema/openapi/backend';

/**
 * Seam-C tenant bind (workspace#49 option C, layer 3).
 *
 * Instantiates the engine taxon module with rcprofi's `TaxonMenu` schema at
 * module scope. Re-exports the record's members under their pre-seam names
 * so `taxon/getTaxonsRootMenu.ts` and `taxon/getTaxonsTree.ts` callers
 * repoint here with an import-line-only change.
 */

const taxonModule = makeTaxonModule({ taxonMenu: TaxonMenu });

export const listCategoryRootMenu = taxonModule.listCategoryRootMenu();
export type CategoryListRootMenuError = BackendApiErrorUnion<
  typeof taxonModule.ListCategoryRootMenuError
>;

export const listTaxonTree = taxonModule.listTaxonTree;
export type TaxonListTreeError = BackendApiErrorUnion<typeof taxonModule.ListTaxonTreeError>;
